module.exports = __webpack_public_path__ + "media/images/flags/1x1/zmb-201a11a637855f0daec3f867e71d6917.svg";